<div class="modal-header bg-head py-2 d-flex justify-content-between align-items-center">
  <h6 class="modal-title mb-0">Admin : Question Management : Shuffling</h6>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="onCross()"
  ></button>
</div>
<div class="row">
  <div class="col-12 border-bottom headersize py-2">
    <span class="px-4 my-2 path-class" > {{path}}</span>
  </div>
</div>
<div class="modal-body m-body pt-0 px-0" >
  <!-- Apply cdkDropListAutoScroll to the parent container -->
  <div
  class="row g-3 px-3"
  style="height: 80vh; overflow-y: auto;"
  #dropListContainer class="example-container"
  cdkDropListGroup
  cdkDropListAutoScroll
  >
    <div class="w-49"
    *ngFor="let question of Questions; let i = index"
    cdkDropList
    [cdkDropListData]="i"
    >
      <div

      cdkDrag
      [cdkDragData]="i"
      (cdkDragEntered)="dragEntered($event)"
      (cdkDragMoved)="dragMoved($event)"
      (cdkDragDropped)="dragDropped($event)"
      class="example-box-shuffle"
      [ngStyle]="{ 'background-color': isHighlighted(i) ? '#ed7c31' : '#2E77AE' }"
      >
        <!-- Question Container -->
        <div
        [ngStyle]="{ 'background-color': isHighlighted(i) ? '#ed7c31' : '#2E77AE' }"
          class=" w-100 "
          style="
          max-width: 100%;
          height: 100%;
          "
        >
        <h4 class="headertext-color-shuffle text-center mb-3 d-flex align-items-center justify-content-center position-relative">
          {{ question.Question_ID }} <span style="font-size: 14px; margin-left: 10px;"> {{printQuestionDetails(question)}} </span>
          <div class="position-absolute d-flex align-items-center fs-6" style="right:20px">
           <span class="me-2" *ngIf="question.Display_Order"> {{question.Display_Order}}</span>
           <i class="fa fa-pencil-square-o fs-5 pointer-cursor"(click)="triggerParentFunction(question)" aria-hidden="true"></i>
          </div>
          <span class="position-absolute fs-6" style="left:20px" *ngIf="question.Question_Status_Type_Name">{{question.Question_Status_Type_Name}}</span>
          <span class="position-absolute fs-6" style="left:20px;bottom:-344px;" *ngIf="question.Creation_Date">Created By : {{question.Created_By}}  ({{question.Creation_Date | date: 'short'}})  </span>
          <span class="position-absolute fs-6" style="right:20px; bottom:-344px;" *ngIf="question.Creation_Date">Updated  By : {{question.Created_By}}  ({{question.Creation_Date | date: 'short'}}) </span>
        </h4>


          <div
            class="row bg-white mx-4 mt-2 q-container"
            style="
              max-height: 300px;
              min-height: 300px;
              overflow-y: auto;
            "
          >
            <!-- Question Text Area with Scrollbar -->
            <div
              class="col-12 mb-2 question-text-area"
              style="
                word-wrap: break-word;
                text-align: left;
                padding: 10px;
                border: 1px solid #ddd;
                border-radius: 4px;
                background-color: #f8f9fa;
              "
            >
              <span
                class="d-block"
                [innerHtml]="SanitizeHTML(question.Question_Text ?? '')"
              ></span>
            </div>

            <!-- Answers -->
            <div class="col-12">
              <div
                class="row align-items-center py-1"
                *ngFor="let answer of question.AllAnswers"
              >
                <div class="col-4 col-md-3 text-end pe-2 AnswerChoicelabel">
                  {{ answer?.Right_Answer_Ind === 'Y' ? 'Right Answer' : 'Wrong Answer' }}:
                </div>
                <div class="col-8 col-md-9 AnswerChoicelabel1">
                  <div
                    class="d-block"
                    [innerHtml]="SanitizeHTML(answer?.Answer_Choice_Text ?? '')"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer d-flex justify-content-end gap-2">
  <button
    type="button"
    class="bl-btn btn btn-sm px-3"
    (click)="onSave()"
  >
    Save
  </button>
  <button
    type="button"
    class="btn btn-sm bg-light border px-3"
    (click)="onCross()"
  >
    Cancel
  </button>
</div>
